// Thin wrapper over posthog-js. Keeps the rest of the app decoupled from
// the analytics provider — swap PostHog for something else later without
// touching 20 call sites.
//
// No-op when REACT_APP_POSTHOG_KEY is absent (local dev without PostHog),
// so tests and local runs don't need to configure anything.
import posthog from 'posthog-js';

let _initialized = false;

export function initAnalytics() {
  if (_initialized) return;
  if (typeof window === 'undefined') return;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com';
  if (!key) return;

  posthog.init(key, {
    api_host: host,
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    persistence: 'localStorage+cookie',
    // Respect Do Not Track
    respect_dnt: true,
    // Disable debug console spam in prod
    loaded: (ph) => {
      if (process.env.NODE_ENV === 'production') ph.debug(false);
    },
  });
  _initialized = true;
}

/**
 * Bind the current session to a user. Call once after login resolves
 * the Firebase user + tenantId + role.
 */
export function identify(uid, traits = {}) {
  if (!_initialized || !uid) return;
  posthog.identify(uid, traits);
  if (traits.tenantId) {
    posthog.group('tenant', String(traits.tenantId));
  }
}

/**
 * Track a business event. Use sparingly — autocapture already captures
 * clicks/pageviews. Only for events that matter for product decisions.
 */
export function track(event, props = {}) {
  if (!_initialized) return;
  posthog.capture(event, props);
}

/**
 * Clear the user binding on logout — next session is treated as anonymous
 * until a new identify() call.
 */
export function resetAnalytics() {
  if (!_initialized) return;
  posthog.reset();
}
